module.exports = __webpack_public_path__ + "static/ga_integration_7-25124399e0038b5a64bbab625614a6a0.png";